import { useState, useRef } from 'react';
import './Formcss.css';
import CustomCard from '../customCard/CustomCard';
import SaveButton from '../Button/SaveButton';
const PlayerForm = () => {
    const canvasRef = useRef(null);
    const smallCardCanvasRef = useRef(null);
    const [cardData, setCardData] = useState(
        {
            Show: 'Game card',
            Language: 'English',
            Name: 'Neymar',
            LastName: 'Jr.',
            Position: 'AM',
            Nationality: 'Brazil',
            PlayerType: 'Normal',
            CardType: 'Normal',
            Foot: 'Right',
            Height: 175,
            ShowPrice: 'Show',
            Price: 2145,
            Rating: 82,
            Year: 2025,
            Speed: 72,
            Acceleration: 81,
            Stamina: 72,
            Strength: 69,
            Control: 90,
            Passing: 85,
            Shooting: 84,
            Tackling: 47,
        }
    );
    const formData =
        [
            {
                "title": "Show",
                "type": "dropdown",
                "options": ["Game card", "Player card"]
            },
            {
                "title": "Language",
                "placeholder": "English",
                "type": "dropdown",
                "options": ["English"]
            },
            {
                "title": "Name",
                "placeholder": "Cristiano",
                "type": "text"
            },
            {
                "title": "LastName",
                "placeholder": "Ronaldo",
                "type": "text"
            },
            {
                "title": "Position",
                "placeholder": "CF",
                "type": "dropdown",
                "options": ["CF", "SS", "RW", "LW", "CM", "RM", "LM", "RWB", "LWB", "CB", "GK", "LB", "RB", "AM", "CM", "DM"]
            },
            {
                "title": "Year",
                "placeholder": "1998",
                "type": "text",
            },
            {
                "title": "Nationality",
                "placeholder": "Portugal",
                "type": "dropdown",
                "options": [
                    "Albania",
                    "Algeria",
                    "Angola",
                    "Antigua and Barbuda",
                    "Argentina",
                    "Armenia",
                    "Australia",
                    "Austria",
                    "Azerbaijan",
                    "Bahamas",
                    "Bahrain",
                    "Bangladesh",
                    "Barbados",
                    "Belarus",
                    "Belgium",
                    "Belize",
                    "Benin",
                    "Bermuda",
                    "Bhutan",
                    "Bolivia",
                    "Bosnia and Herzegovina",
                    "Botswana",
                    "Brazil",
                    "Bulgaria",
                    "Burundi",
                    "Cambodia",
                    "Cameroon",
                    "Canada",
                    "Cape Verde",
                    "Central African Republic",
                    "Chile",
                    "China",
                    "Colombia",
                    "Comoros",
                    "Costa Rica",
                    "Croatia",
                    "Cuba",
                    "Curacao",
                    "Cyprus",
                    "Czech Republic",
                    "Democratic Republic of the Congo",
                    "Denmark",
                    "Djibouti",
                    "Dominica",
                    "Dominican Republic",
                    "Ecuador",
                    "Egypt",
                    "El Salvador",
                    "England",
                    "Equatorial Guinea",
                    "Estonia",
                    "Eswatini",
                    "Faroe Islands",
                    "Fiji",
                    "Finland",
                    "France",
                    "French Polynesia",
                    "Gabon",
                    "Georgia",
                    "Germany",
                    "Ghana",
                    "Greece",
                    "Grenada",
                    "Guadeloupe",
                    "Guatemala",
                    "Guinea",
                    "Guinea-Bissau",
                    "Guyana",
                    "Haiti",
                    "Honduras",
                    "Hong Kong",
                    "Hungary",
                    "Iceland",
                    "India",
                    "Indonesia",
                    "Iran",
                    "Iraq",
                    "Ireland",
                    "Israel",
                    "Italy",
                    "Ivory Coast",
                    "Jamaica",
                    "Japan",
                    "Jordan",
                    "Kazakhstan",
                    "Kenya",
                    "Kosovo",
                    "Kuwait",
                    "Kyrgyzstan",
                    "Laos",
                    "Latvia",
                    "Lebanon",
                    "Liberia",
                    "Libya",
                    "Liechtenstein",
                    "Lithuania",
                    "Luxembourg",
                    "Macedonia",
                    "Madagascar",
                    "Malawi",
                    "Malaysia",
                    "Malta",
                    "Mali",
                    "Mauritania",
                    "Mauritius",
                    "Mexico",
                    "Moldova",
                    "Monaco",
                    "Mongolia",
                    "Montenegro",
                    "Montserrat",
                    "Morocco",
                    "Mozambique",
                    "Myanmar",
                    "Namibia",
                    "Nepal",
                    "Netherlands",
                    "New Caledonia",
                    "New Zealand",
                    "Nicaragua",
                    "Niger",
                    "Nigeria",
                    "North Korea",
                    "Norway",
                    "Oman",
                    "Pakistan",
                    "Palestine",
                    "Panama",
                    "Paraguay",
                    "Peru",
                    "Philippines",
                    "Poland",
                    "Portugal",
                    "Puerto Rico",
                    "Qatar",
                    "Republic of The Gambia",
                    "Republic of the Congo",
                    "Romania",
                    "Russia",
                    "Rwanda",
                    "San Marino",
                    "Saudi Arabia",
                    "Scotland",
                    "Senegal",
                    "Serbia",
                    "Seychelles",
                    "Sierra Leone",
                    "Singapore",
                    "Slovakia",
                    "Slovenia",
                    "Somalia",
                    "South Africa",
                    "South Korea",
                    "South Sudan",
                    "Spain",
                    "Sri Lanka",
                    "Sudan",
                    "Suriname",
                    "Sweden",
                    "Switzerland",
                    "Syria",
                    "Tanzania",
                    "Thailand",
                    "Togo",
                    "Trinidad and Tobago",
                    "Tunisia",
                    "Turkey",
                    "Uganda",
                    "Ukraine",
                    "United Arab Emirates",
                    "United Kingdom",
                    "United States of America",
                    "Uruguay",
                    "USSR",
                    "Uzbekistan",
                    "Venezuela",
                    "Vietnam",
                    "Wales",
                    "World",
                    "Yemen",
                    "Yugoslavia",
                    "Zambia",
                    "Zimbabwe"
                ]
            },
            {
                "title": "Player Type",
                "placeholder": "Normal",
                "type": "dropdown",
                "options": ["Normal", "Star", "Classic", "Champion", "Team of 2025"]
            },
            {
                "title": "Card Type",
                "placeholder": "Normal",
                "type": "dropdown",
                "options": ["Normal", "Maxed"]
            },
            {
                "title": "Foot",
                "placeholder": "Both",
                "type": "dropdown",
                "options": ["Left", "Right", "Both"]
            },
            {
                "title": "Height",
                "placeholder": "187",
                "type": "text"
            },
            {
                "title": "Show Price",
                "placeholder": "Show",
                "type": "dropdown",
                "options": ["Show", "Hide"]
            },
            {
                "title": "Price",
                "placeholder": "2145",
                "type": "text"
            },
            {
                "title": "Rating",
                "placeholder": "82",
                "type": "text"
            },
            {
                "title": "Speed",
                "placeholder": "77",
                "type": "text"
            },
            {
                "title": "Acceleration",
                "placeholder": "78",
                "type": "text"
            },
            {
                "title": "Stamina",
                "placeholder": "80",
                "type": "text"
            },
            {
                "title": "Strength",
                "placeholder": "79",
                "type": "text"
            },
            {
                "title": "Control",
                "placeholder": "83",
                "type": "text"
            },
            {
                "title": "Passing",
                "placeholder": "81",
                "type": "text"
            },
            {
                "title": "Shooting",
                "placeholder": "85",
                "type": "text"
            },
            {
                "title": "Tackling",
                "placeholder": "76",
                "type": "text"
            }
        ]
        ;




    return (
        <>
            <div class="card my-3 py-3">

                {/* <CustomCard name={`${cardData.Name} ${cardData.LastName}`} /> */}
                <CustomCard cardData={cardData} canvasRef={canvasRef} smallCardCanvasRef={smallCardCanvasRef} />
            </div>

            <div className='row container mx-auto'>
                {
                    formData.map((item, index) => {
                        const key = item.title.replace(/\s+/g, '');

                        if (item.title === "Year" && cardData.PlayerType === "Normal") {
                            return null;
                        }

                        let dynamicTitle = item.title;
                        if (cardData.Position === "GK") {
                            if (item.title === "Stamina") dynamicTitle = "GK Reactions";
                            if (item.title === "Shooting") dynamicTitle = "GK Handling";
                        }

                        // Detect screen width
                        const screenWidth = window.innerWidth;
                        const isRating = item.title === "Rating";

                        let columnClass = "col-md-4"; // default for large screens

                        if (screenWidth < 750) {
                            columnClass = isRating ? "col-12" : "col-6";
                        }

                        if (item.type === 'dropdown') {
                            return (
                                <div className={`${columnClass} form-group`} key={index}>
                                    <label>{dynamicTitle}</label>
                                    <select
                                        value={cardData[key]}
                                        onChange={(e) => setCardData({ ...cardData, [key]: e.target.value })}
                                    >
                                        {item.options.map((option, idx) => (
                                            <option key={idx} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>
                            )
                        }

                        if (item.type === 'text') {
                            const limitedFields = [
                                "Rating", "Speed", "Acceleration", "Stamina", "Strength",
                                "Control", "Passing", "Shooting", "Tackling"
                            ];

                            const rangedFields = {
                                "Height": { min: 140, max: 210 },
                                "Price": { min: 0, max: 9999 }
                            };

                            const isLimited = limitedFields.includes(item.title);
                            const isRanged = Object.prototype.hasOwnProperty.call(rangedFields, item.title);

                            return (
                                <div className={`${columnClass} form-group`} key={index}>
                                    <label className='b-3'>{dynamicTitle}</label>
                                    <input
                                        type={isLimited || isRanged ? "number" : "text"}
                                        value={cardData[key] ?? ""}
                                        min={isRanged ? rangedFields[item.title].min : isLimited ? 0 : undefined}
                                        max={isRanged ? rangedFields[item.title].max : isLimited ? 100 : undefined}
                                        onChange={(e) => {
                                            const rawValue = e.target.value;
                                            if (rawValue === "") {
                                                setCardData({ ...cardData, [key]: "" });
                                                return;
                                            }
                                            setCardData({ ...cardData, [key]: rawValue });
                                        }}
                                        onBlur={() => {
                                            const raw = cardData[key];

                                            if (raw === "") return;

                                            const num = Number(raw);
                                            if (isNaN(num)) return;

                                            let clamped = num;

                                            if (isRanged) {
                                                const { min, max } = rangedFields[item.title];
                                                clamped = Math.max(min, Math.min(max, num));
                                            } else if (isLimited) {
                                                clamped = Math.max(0, Math.min(100, num));
                                            }

                                            setCardData({ ...cardData, [key]: clamped.toString() });
                                        }}
                                    />
                                </div>
                            );
                        }
                    })
                }
            </div>



            <SaveButton bigCard={canvasRef} smallCard={smallCardCanvasRef} />
            
          
        </>
    );
};

export default PlayerForm;
